// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { withRouter } from "react-router";
import { itemList, Link, Select, LabeledBadge } from "@lifepay/rc-ui-toolkit";
import SplitPane from "react-split-pane";
import { pluralize } from "numeralize-ru";
import { Scrollbars } from "react-custom-scrollbars";
import { Redirect } from "react-router-dom";

// import Draggable from "react-draggable";
// import "react-resizable/css/styles.css";

// ABSOLUTE PATH IMPORTS
import { PERMISSION_KEYS } from "accessConfig";
import actions from "model/actions";
import { ROUTES } from "model/subsystems/app/CONSTANTS";
import selectors from "model/selectors";
import Company, { CompanyHeader } from "components/list-items/compact/Company";
import Merchant, {
  MerchantHeader,
} from "components/list-items/compact/Merchant";
import Terminal, {
  TerminalHeader,
} from "components/list-items/compact/Terminal";
import Transaction, {
  TransactionHeader,
  ExtendedTransaction,
} from "components/list-items/compact/Transaction";

import List from "./List";

import styles from "./Data.m.scss";

@withRouter
// connecting component to the redux store
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      canViewCompanies: selectors.access.getPermission(
        state,
        PERMISSION_KEYS.PR_VIEW_COMPANIES
      ),
      canViewMerchants: selectors.access.getPermission(
        state,
        PERMISSION_KEYS.PR_VIEW_MERCHANTS
      ),
      canViewTerminals: selectors.access.getPermission(
        state,
        PERMISSION_KEYS.PR_VIEW_TERMINALS
      ),
      canViewTransactions: selectors.access.getPermission(
        state,
        PERMISSION_KEYS.PR_VIEW_TRANSACTIONS
      ),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {
    goToCompanies: actions.app.router.createGoTo(ROUTES.PROCESSING_COMPANIES),
    goToMerchants: actions.app.router.createGoTo(ROUTES.PROCESSING_MERCHANTS),
    goToTerminals: actions.app.router.createGoTo(ROUTES.PROCESSING_TERMINALS),
    goToTransactions: actions.app.router.createGoTo(
      ROUTES.PROCESSING_TRANSACTION
    ),
  }
)
@themr("processing/data", styles)
export default class Acquiring extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object, // object with css class names
    history: PropTypes.object,
    match: PropTypes.object,
    basePath: PropTypes.string,
    location: PropTypes.object,
    goToCompanies: PropTypes.func,
    goToMerchants: PropTypes.func,
    goToTerminals: PropTypes.func,
    goToTransactions: PropTypes.func,
    canViewCompanies: PropTypes.bool,
    canViewMerchants: PropTypes.bool,
    canViewTerminals: PropTypes.bool,
    canViewTransactions: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      companiesFilters: {},
      merchantsFilters: {},
      terminalsFilters: {},
      transactionsFilters: {},
      selectedCompany: null,
      selectedMerchant: null,
      selectedTerminal: null,
      selectedTransaction: null,
      itemsPerPage: 20,
    };
  }

  changeItemsPerPage = ({ value }) => {
    this.setState({ itemsPerPage: value });
  };

  selectCompany = (item) => {
    this.setState({ selectedCompany: item });
  };

  selectMerchant = (item) => {
    this.setState({ selectedMerchant: item });
  };

  selectTerminal = (item) => {
    this.setState({ selectedTerminal: item });
  };

  selectTransaction = (item) => {
    this.setState({ selectedTransaction: item });
  };

  saveLastFilter = ({ id, value }) => {
    this.setState({ [`${id}Filters`]: value });
  };

  render() {
    const {
      theme,
      history,
      location,
      match,
      basePath,
      goToCompanies,
      goToMerchants,
      goToTerminals,
      goToTransactions,
      canViewCompanies,
      canViewMerchants,
      canViewTerminals,
      canViewTransactions,
    } = this.props;
    const {
      companiesFilters,
      merchantsFilters,
      terminalsFilters,
      transactionsFilters,
      selectedCompany,
      selectedMerchant,
      selectedTerminal,
      selectedTransaction,
      itemsPerPage,
    } = this.state;

    const route = match.params.subdir;
    let activeTab = null;
    let Header;
    let showExtendedInfo = false;
    let ExtendedInfo;
    let selectedItem;
    let item;
    let savedFilters;
    let redirect;
    switch (route) {
      case "companies": {
        if (!canViewCompanies) {
          redirect = true;
        }
        activeTab = "COMPANIES";
        Header = CompanyHeader;
        item = Company;
        selectedItem = selectedCompany;
        savedFilters = companiesFilters;
        break;
      }
      case "merchants": {
        if (!canViewMerchants) {
          redirect = true;
        }
        activeTab = "MERCHANTS";
        Header = MerchantHeader;
        item = Merchant;
        selectedItem = selectedMerchant;
        savedFilters = merchantsFilters;
        break;
      }
      case "terminals": {
        if (!canViewTerminals) {
          redirect = true;
        }
        activeTab = "TERMINALS";
        Header = TerminalHeader;
        item = Terminal;
        selectedItem = selectedTerminal;
        savedFilters = terminalsFilters;
        break;
      }
      case "transactions": {
        if (!canViewTransactions) {
          redirect = true;
        }
        activeTab = "TRANSACTIONS";
        showExtendedInfo = true;
        ExtendedInfo = ExtendedTransaction;
        Header = TransactionHeader;
        item = Transaction;
        selectedItem = selectedTransaction;
        savedFilters = transactionsFilters;
        break;
      }
    }
    if (redirect) {
      let path = "/";
      if (canViewTransactions) {
        path = match.path.replace(":subdir", "transactions");
      } else if (canViewTerminals) {
        path = match.path.replace(":subdir", "terminals");
      } else if (canViewMerchants) {
        path = match.path.replace(":subdir", "merchants");
      } else if (canViewCompanies) {
        path = match.path.replace(":subdir", "companies");
      }
      return <Redirect to={path} />;
    }

    return (
      <React.Fragment>
        <List
          listType={activeTab}
          history={history}
          location={location}
          itemsPerPage={itemsPerPage}
          saveFilters={this.saveLastFilter}
          savedFilters={savedFilters}
        >
          {(listProps) => (
            <React.Fragment>
              <div className={classnames(theme.nav)}>
                <div className={classnames(theme.menu)}>
                  <div className={classnames(theme.links)}>
                    {canViewCompanies && (
                      <div
                        className={classnames(
                          theme.link,
                          activeTab === "COMPANIES" && theme.active
                        )}
                        onClick={() => {
                          history.push(`${basePath}/companies`);
                        }}
                      >
                        {"Компании"}
                      </div>
                    )}
                    {canViewMerchants && (
                      <div
                        className={classnames(
                          theme.link,
                          activeTab === "MERCHANTS" && theme.active
                        )}
                        onClick={() => {
                          history.push(`${basePath}/merchants`);
                        }}
                      >
                        {"Точки обслуживания"}
                      </div>
                    )}

                    {canViewTerminals && (
                      <div
                        className={classnames(
                          theme.link,
                          activeTab === "TERMINALS" && theme.active
                        )}
                        onClick={() => {
                          history.push(`${basePath}/terminals`);
                        }}
                      >
                        {"Терминалы"}
                      </div>
                    )}

                    {canViewTransactions && (
                      <div
                        className={classnames(
                          theme.link,
                          activeTab === "TRANSACTIONS" && theme.active
                        )}
                        onClick={
                          activeTab !== "TRANSACTIONS"
                            ? () => {
                                history.push(`${basePath}/transactions`);
                              }
                            : undefined
                        }
                      >
                        {"Транзакции"}
                      </div>
                    )}
                  </div>
                  <div className={classnames(theme.total)}>
                    {listProps.totalItems &&
                      `Всего ${listProps.totalItems} ${pluralize(
                        listProps.totalItems,
                        "запись",
                        "записи",
                        "записей"
                      )}.`}
                  </div>
                </div>
                <div className={classnames(theme.meta)}>
                  <div className={classnames(theme["page-count-control"])}>
                    <Select
                      name={"itemsPerPage"}
                      id={"itemsPerPage"}
                      value={this.state.itemsPerPage}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                      onChange={this.changeItemsPerPage}
                      hideChooseAll
                      label={false}
                      theme={{
                        wrapper: theme.select,
                        select: theme.inner,
                        render: theme.render,
                      }}
                    />
                    {`записей на странице.`}
                  </div>
                  <div className={classnames(theme.link)}>
                    <Link
                      withRouter={false}
                      disabled={
                        listProps.currentPage === 1 || !listProps.maxPage
                      }
                      type={
                        listProps.currentPage === 1 || !listProps.maxPage
                          ? "disabled"
                          : "main"
                      }
                      onClick={listProps.getPrevPage}
                    >{`Предыдущая`}</Link>
                  </div>
                  <div className={classnames(theme.pages)}>
                    {listProps.maxPage
                      ? `Страница ${listProps.currentPage} из ${
                          listProps.maxPage
                        }`
                      : [
                          itemList.CONSTANTS.DATA_STATE.LOADING,
                          itemList.CONSTANTS.DATA_STATE.RELOADING,
                        ].includes(listProps.dataState)
                        ? "Обновляем"
                        : "Нет данных"}
                  </div>
                  <div className={classnames(theme.link)}>
                    <Link
                      withRouter={false}
                      disabled={
                        listProps.currentPage === listProps.maxPage ||
                        !listProps.maxPage
                      }
                      type={
                        listProps.currentPage === listProps.maxPage ||
                        !listProps.maxPage
                          ? "disabled"
                          : "main"
                      }
                      onClick={listProps.getNextPage}
                    >{`Следующая`}</Link>
                  </div>
                </div>
              </div>
              <div className={classnames(theme.controls)}>
                {/* <Scrollbars> */}
                <itemList.Controls
                  theme={{
                    wrapper: theme["controls-wrapper"],
                    group: theme["controls-group"],
                  }}
                  {...listProps}
                />
                {/* </Scrollbars> */}
              </div>
              <div className={classnames(theme.header)}>
                {
                  <Header
                    setFilter={listProps.handleInputChange}
                    sortById={listProps.currentFilters.sortById}
                    sortByDate={listProps.currentFilters.sortByDate}
                  />
                }
              </div>
              <div className={classnames(theme.content)}>
                <SplitPane
                  key={activeTab}
                  split="horizontal"
                  defaultSize={"60%"}
                  size={showExtendedInfo ? undefined : "100%"}
                  allowResize={showExtendedInfo}
                >
                  <Scrollbars>
                    <div className={classnames(theme.results)}>
                      <itemList.Results
                        {...listProps}
                        usePaginator={false}
                        // Header={header}
                        Item={item}
                        ItemProps={{
                          selectCompany: this.selectCompany,
                          selectMerchant: this.selectMerchant,
                          selectTerminal: this.selectTerminal,
                          selectTransaction: this.selectTransaction,
                          goToCompanies,
                          goToMerchants,
                          goToTerminals,
                          goToTransactions,
                          selectedCompany,
                          selectedMerchant,
                          selectedTerminal,
                          selectedTransaction,
                        }}
                      />
                    </div>
                  </Scrollbars>
                  <div className={classnames(theme.info)}>
                    {selectedItem && ExtendedInfo ? (
                      <ExtendedInfo
                        item={selectedItem}
                        transactionId={selectedItem.transactionId}
                        isReversal={selectedItem.isReversal}
                        goToCompanies={goToCompanies}
                        goToMerchants={goToMerchants}
                        goToTerminals={goToTerminals}
                        goToTransactions={goToTransactions}
                        selectTransaction={this.selectTransaction}
                      />
                    ) : (
                      <LabeledBadge
                        firstNode={"Выберите"}
                        secondNode={"запись"}
                      />
                    )}
                  </div>
                </SplitPane>
              </div>
            </React.Fragment>
          )}
        </List>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-processing/Data/Data.js